export default __webpack_public_path__ + "static/media/218.e6b87b68.png";